import { useState } from 'react';

import { yoplPartnerFfvLicenseCheck } from '../constants';
import { addQueryParamToUrl, jsonToQueryParams } from '../utils/requestUtil';
import useFetch from './useFetch';

const useFetchFfvLicense = relatedSessionGroupId => {
  const [fetchUrl, setFetchUrl] = useState(null);
  const { data, status } = useFetch(fetchUrl);

  const triggerFetchFfvLicense = data => {
    let url = yoplPartnerFfvLicenseCheck(relatedSessionGroupId);
    url = addQueryParamToUrl(url, jsonToQueryParams(data));
    setFetchUrl(url);
  };

  return { data, status, triggerFetchFfvLicense };
};

export default useFetchFfvLicense;
